export default [
  {
    width: 100,
    header: {
      type: 'text',
      caption: 'Date',
    },
    cell: {
      type: 'text',
      value: (e) => e.date,
    },
  },
];
